import { api } from "~/utils/api";

export const DevPanelUserData = () => {
  const [user] = api.user.getUser.useSuspenseQuery();

  if (!user) return <div>Cannot find user data</div>;
  return (
    <div>
      <p>
        <b>ID:</b> {user.id}
      </p>
      <p>
        <b>Name:</b> {user.name}
      </p>
      <p>
        <b>Email:</b> {user.email}
      </p>
      <p>
        <b>Created At:</b> {user.createdAt.toLocaleString()}
      </p>
      <p>
        <b>Wallet:</b> {user.wallet.toString()}
      </p>
      <p>
        <b>Opt in Marketing:</b> {user.optInMarketing ? "Yes" : "No"}
      </p>
    </div>
  );
};
